import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FilterGroup from '../../../molecules/filter/FilterGroup';
import FilterCheckbox from '../../../atoms/filters/FilterCheckbox';
import Label from '../../../atoms/labels/Label';
import Flex from '../../../atoms/Flex';
import styled from 'styled-components';
import _ from 'lodash';
const StyledFilterGroup = styled(FilterGroup) `
    position: sticky;
    top: 100px;
    background-color: white;
    padding-bottom: 15px;
    margin-bottom: 25px;
    z-index: 1;

    &:before {
        content: '';
        position: absolute;
        top: -40px;
        left: 0;
        width: 100%;
        height: 40px;
        background-color: white;
    }
`;
const Filters = ({ filters, onChange: handleChange, }) => {
    return (_jsx(StyledFilterGroup, { children: _jsxs(Flex, { children: [_jsx(Flex, { margin: "8px 10px 0 0", children: _jsx(Label, { children: "Filters" }) }), _jsx(Flex, { flexWrap: "wrap", children: filters.map((filter, index) => (_jsx(FilterCheckbox, { label: _.upperFirst(filter), id: filter, type: filter, onChange: handleChange }, filter + index))) })] }) }));
};
export default Filters;
